import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit } from "./Components/Services";

export const input = [
  {
    label: "عنوان تگ",
    size: "col-12",
    classNames: "mt-2",
    placeholder: "",
    name: "name",
    input: "text",
  },
  {
    label: "کلمات کلیدی سئو",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoKeyword",
    value: "",
    input: "textarea",
  },
  {
    label: "توضیحات کلیدی سئو",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoDescription",
    value: "",
    input: "textarea",
  },
];
function Create() {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);

  const Handler = data => {
    setstate({ loading: true });
    FormSubmit(data).then(() => {
      setstate({
        loading: false,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ثبت تگ</title>
      </Helmet>
      <CommonFrom
        form={input}
        loading={state.loading}
        header="ایجاد تگ"
        textbtn="لیست تگ ها"
        linkbtn="/Admin/Tag/List"
        btnName="ایجاد تگ"
        submit={Handler}
      />
    </Fragment>
  );
}

export default Create;
